import React from 'react';
import Loader from 'src/components/loader';
import loadable from '@loadable/component';
import infoPageQuery from './query.graphql';
import PropTypes from 'prop-types';

const InfoPage = loadable(
  () => import(/* webpackChunkName: "info-page" */ './info-page'),
  {
    fallback: <Loader />,
  }
);

InfoPage.variables = ({ id }) => ({ id });

InfoPage.graphQL = infoPageQuery;

InfoPage.loadOrder = [{}];

InfoPage.propTypes = {
  data: PropTypes.shape({
    pageContent: PropTypes.any,
  }),
};

InfoPage.defaultProps = {
  data: {
    pageContent: undefined,
  },
};

export default InfoPage;
